import yearly2025 from "./yearly_2025.js";
import yearly2024 from "./yearly_2024.js";
import yearly2023 from "./yearly_2023.js";
import yearly2022 from "./yearly_2022.js";
import yearly2021 from "./yearly_2021.js";

export { yearly2025, yearly2024, yearly2023, yearly2022, yearly2021 };

export default {
  yearly2025,
  yearly2024,
  yearly2023,
  yearly2022,
  yearly2021,
};
